import { Body1, H3 } from '@xo-union/tk-ui-typography';
import { FullBleedContainer, TopLevelContainer, Row, Column } from '@xo-union/tk-component-grid';
import Honeybadger from 'honeybadger-js';
import React, { useContext, useEffect, useState } from 'react';

import { useDismissPromotionMutation, usePrintPromotionMutation } from '../../generated/graphql';
import { TrackingContext } from '../../TrackingContext';
import shared from '../InfoHeader/infoHeader.scss';
import { Link } from '@xo-union/tk-component-buttons';
import LinkButton from '../LinkButton';
import DashboardActionButtons from '../DashboardActionButtons';
import styles from './style.scss';

const Promotion = () => {
  const [printPromotion, { data }] = usePrintPromotionMutation();
  const [dismissPromotion] = useDismissPromotionMutation();
  const [dismissed, setDismissed] = useState(false);
  const { track } = useContext(TrackingContext);

  useEffect(() => {
    (async () => {
      try {
        await printPromotion();
      } catch (error) {
        Honeybadger.notify(error, { message: 'Error getting promotion', context: { error } });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data || !data.printPromotion) {
    return null;
  }

  const onDismiss = async () => {
    try {
      if (data.printPromotion?.id) {
        track('user clicks dismiss');
        await dismissPromotion({
          variables: { id: data.printPromotion.id },
          update() {
            setDismissed(true);
          },
        });
      }
    } catch (error) {
      Honeybadger.notify(error, { message: 'Error dismissing promotion', context: { error } });
    }
  };

  const onCtaAnalytics = () => {
    track('WWS Dashboard Interaction', {
      action: 'add',
      actionName: 'registry',
      source: 'wws promo',
    });
  };

  const { imageUrl, title, description, mainCtaUrl } = data.printPromotion;
  return (
    <FullBleedContainer>
      <div className={`${shared.container} ${styles.container} ${styles.promotion}`}>
        <TopLevelContainer>
          <Row>
            <Column xs="12">
              <div className={`${shared.wrapper} ${styles.wrapper}`}>
                {!dismissed && (
                  <>
                    <div className={styles.promoImage}>
                      {imageUrl && <img className={styles.img} src={imageUrl} alt={title || 'promotion image'} />}
                    </div>
                    <div className={styles.promoContent}>
                      <H3 as="h2">{title}</H3>
                      <Body1 className={styles.body}>{description}</Body1>
                      <div className={styles.buttonWrapper}>
                        <Link
                          data-testid="promotion-cta"
                          color="secondary-alternative"
                          size="sm"
                          href={mainCtaUrl || '/'}
                          onClick={onCtaAnalytics}
                        >
                          Get started
                        </Link>
                        <LinkButton data-testid="promotion-dismiss" className={styles.dismiss} onClick={onDismiss}>
                          Maybe later
                        </LinkButton>
                      </div>
                    </div>
                  </>
                )}
                <div className={styles.actionButtons}>
                  <DashboardActionButtons className={styles.promtionActionButtons} />
                </div>
              </div>
            </Column>
          </Row>
        </TopLevelContainer>
      </div>
    </FullBleedContainer>
  );
};

export default Promotion;
